EventEmitter = require('backbone').Events
$ = require 'jquery'
_ = require 'underscore'

# Triggers an event ('nearEnd') when the user scrolls the scrollable container
# to near the end of the list element. This event can be used to load more
# content into the list element.
#
# The event will only be triggered once. Call reset() once the list element has
# a greater height (i.e. there is more content for the user to scroll through).
#
# By default it listens to scrolling on the #content element.
#
# Usage:
# infiniteScroll = new InfiniteScroll('.my-list')
# infiniteScroll.on 'nearEnd', -> loadMoreThings().then(infiniteScroll.reset)
module.exports = class InfiniteScroll
  _.extend @::, EventEmitter

  constructor: (listElement, options) ->
    @options = _.extend(
        scrollableContainer: '#content'
        # point along listElement's height at which to trigger
        threshold: 0.75
        # minimum milliseconds between scrollTop evaluations
        debounce: 50
      , options ? {}
    )
    @$scrollableContainer = $(@options.scrollableContainer)
    @$getListElement = -> $(listElement)

    @reset()
    debouncedScrollHandler = _.debounce @_onScroll.bind(@), @options.debounce
    @$scrollableContainer.scroll debouncedScrollHandler

  destroy: ->
    @$scrollableContainer.off 'scroll'

  _scrollBottom: ->
    @$scrollableContainer.height() -
      ((@$getListElement().offset()?.top || 0) - @containerOffset)

  _listHeight: ->
    @$getListElement().height()

  _onScroll: ->
    return if @locked
    scrollBottom = @_scrollBottom()
    if (scrollBottom / @_listHeight()) > @options.threshold
      @locked = true
      @trigger 'nearEnd'
    else
      @previousScrollBottom = scrollBottom

  reset: ->
    @locked = false
    # we're assuming this won't normally change
    @containerOffset = @$scrollableContainer.offset()?.top
    @previousScrollBottom = @_scrollBottom()

    # Run immediately, in case the container is larger than the list and so no
    # scrolling event will occur
    @_onScroll()



// WEBPACK FOOTER //
// ./app/scripts/views/lib/infinite-scroll.coffee